module.exports = __webpack_public_path__ + "img/poer3_bg.f6294768.jpg";